<div fxFill fxLayout="column" fxLayoutAlign="start center">
  <!-- HEADER -->
  <app-header-noauth
    *ngIf="!isChangedPasswordFromHome"
    class="appHeader appHeader--sticky appHeader--noauth"
  ></app-header-noauth>

  <!-- BODY -->
  <div class="wrapper wrapper--noauth" fxLayoutAlign="center center" fxFlex="100%">
    <div class="wrapper__content">
      <mat-card class="password__card">
        <mat-card-header>
          <mat-card-title translate>matcard.h2</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p translate>matcard.p</p>
          <mat-divider class="divider--top"></mat-divider>
          <div>
            <div class="alert alert--warning" style="width: fit-content" fxLayoutAlign="start center">
              <mat-icon class="icon-ic_warning icon-size"></mat-icon>
              <span class="span__no-password" translate>matcard.warning</span>
            </div>
            <!--Inputs-->
            <form fxLayout="column" [formGroup]="passwordForm">
              <div [fxLayout]="isMobile ? 'column' : 'wrap'" fxLayoutAlign="space-between center" fxLayoutGap="1.5rem">
                <mat-form-field appearance="outline" fxFlex [ngClass]="isMobile ? 'card__inputs' : undefined">
                  <mat-label translate>matcard.form.field.label.usuario</mat-label>
                  <input
                    id="userNamePassword"
                    type="text"
                    matInput
                    formControlName="usuario"
                    [readonly]="!isRecovery"
                    autocomplete="off"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex [ngClass]="isMobile ? 'card__inputs' : undefined">
                  <mat-label translate>matcard.form.field.label.currentpassword</mat-label>
                  <input
                    id="currentPasswordPassword"
                    matInput
                    type="password"
                    formControlName="currentPassword"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>

              <h4 translate>matcard.form.h3</h4>
              <div
                [fxLayout]="isMobile ? 'column' : 'wrap'"
                fxLayoutAlign="space-between center"
                fxFlex
                fxLayoutGap="1.5rem"
              >
                <mat-form-field appearance="outline" fxFlex [ngClass]="isMobile ? 'card__inputs' : undefined">
                  <mat-label translate>matcard.form.field.label.password</mat-label>
                  <input
                    id="newPasswordPassword"
                    matInput
                    type="password"
                    formControlName="password"
                    maxLenght="6"
                    minlength="6"
                    autocomplete="off"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex [ngClass]="isMobile ? 'card__inputs' : undefined">
                  <mat-label translate>matcard.form.field.label.confirmpassword</mat-label>
                  <input
                    id="confirmPasswordPassword"
                    matInput
                    type="password"
                    formControlName="confirmPassword"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
            </form>
            <!-- Validaciónes de contraseñas-->
            <h5 translate>matcard.h5</h5>
            <div class="passwordcheck__list" fxLayout="column">
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon
                  [ngClass]="
                    passwordForm.get('password').errors?.minlength ||
                    passwordForm.get('password').value == '' ||
                    passwordForm.get('password').errors?.maxlength
                      ? undefined
                      : 'primary-icon'
                  "
                >
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.length</span>
              </div>
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon [ngClass]="passwordForm.get('password').errors?.numberInvalid ? undefined : 'primary-icon'">
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.number</span>
              </div>
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon [ngClass]="passwordForm.get('password').errors?.alphabetInvalid ? undefined : 'primary-icon'">
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.alphabetical</span>
              </div>
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon [ngClass]="passwordForm.get('password').errors?.specialInvalid ? undefined : 'primary-icon'">
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.special</span>
              </div>
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon [ngClass]="passwordForm.errors?.usuarioInvalid ? undefined : 'primary-icon'">
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.usuario</span>
              </div>
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon [ngClass]="passwordForm.get('password').errors?.similarInvalid ? undefined : 'primary-icon'">
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.similar</span>
              </div>
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon [ngClass]="passwordForm.get('password').errors?.sequenceInvalid ? undefined : 'primary-icon'">
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.sequence</span>
              </div>
              <div class="passwordcheck__listitem" fxFlex fxLayoutAlign="start start">
                <mat-icon [ngClass]="passwordForm.errors?.confirmedInvalid ? undefined : 'primary-icon'">
                  {{ iconCircle }}
                </mat-icon>
                <span translate>matcard.span.passwords</span>
              </div>
            </div>
          </div>
          <mat-divider class="divider--bottom"></mat-divider>
        </mat-card-content>
        <!-- Botones -->
        <mat-card-actions fxLayoutAlign="end" fxLayoutGap="1rem">
          <button id="cancelButtonPassword" mat-stroked-button color="accent" (click)="cancelarFormulario()">
            <span translate>matcard.button.cancelar</span>
          </button>
          <button
            id="sendPasswordPassword"
            mat-flat-button
            color="accent"
            [disabled]="passwordForm.invalid"
            (click)="enviarFormulario()"
          >
            <span translate>matcard.button.aceptar</span>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
  <!-- FOOTER -->
  <app-footer *ngIf="!isChangedPasswordFromHome" class="appFooter appFooter--noauth"></app-footer>
</div>
